import {del, get} from "../http_client";
import {api_my_credentials_path, api_my_credential_path} from "../../routes";

export const index = () => get({ url: api_my_credentials_path() })
export const destroy = (cred) => del({ url: api_my_credential_path(cred.id) })